<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>vip配置编辑</span>
        </div>
        <el-form ref="formData" :model="formData" :rules="rules" label-width="150px" class="demo-ruleForm">
          <el-form-item label="vip等级" prop="lv">
            <el-input v-model.number="formData.lv" style="width: 400px" />
          </el-form-item>
          <el-form-item label="vip积分" prop="integration">
            <el-input v-model.number="formData.integration" style="width: 400px" />
          </el-form-item>
          <el-form-item label="任务奖励倍率" prop="taskRewardBet">
            <el-input v-model.number="formData.taskRewardBet" style="width: 400px" />
          </el-form-item>
          <el-form-item label="体力恢复增量" prop="spinsRestore">
            <el-input v-model.number="formData.spinsRestore" style="width: 400px" />
          </el-form-item>
          <el-form-item label="盾牌槽增量" prop="shieldGroove">
            <el-input v-model.number="formData.shieldGroove" style="width: 400px" />
          </el-form-item>
          <el-form-item label="头像框" prop="avatarBox">
            <el-select v-model="formData.avatarBox" style="width: 400px" placeholder="请选择">
              <el-option
                v-for="item in avatarBoxArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="商店体力增量" prop="shopAppend">
            <el-input v-model.trim="formData.shopAppend" style="width: 400px" />
          </el-form-item>
          <el-form-item label="打成功金币增加%" prop="shopAppend">
            <el-input v-model.number="formData.attackCoinsPro" style="width: 400px" />
          </el-form-item>
          <el-form-item label="偷钱金币增加%" prop="stealCoinsPro">
            <el-input v-model.trim="formData.stealCoinsPro" style="width: 400px" />
          </el-form-item>
          <el-form-item label="嘲讽图" prop="mock">
            <el-select v-model="formData.mock" style="width: 400px;" placeholder="请选择">
              <el-option
                v-for="item in mockArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('formData')">保存</el-button>
            <el-button @click="resetForm('formData')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getVipCfgList, updateVipCfg } from '@/api/config/vip-cfg'
export default {
  name: 'VipCfgEdit',
  data() {
    return {
      formData: {
        'lv': 0,
        'integration': 0,
        'signInBet': 0,
        'taskRewardBet': 0,
        'spinsRestore': 0,
        'avatarBox': 0,
        'shieldGroove': 0,
        'turnTable': 0,
        'shopAppend': 0,
        'weekRewardSpins': 0,
        'weekRewardShield': 0,
        'weekRewardChest': 0,
        'weekRewardBless': 0,
        'weekRewardLuckydraw': 0,
        'dayVipPoint': 0,
        'attackCoinsPro': 0,
        'stealCoinsPro': 0,
        'attackCss': 0,
        'miningGame': 0,
        'mock': 0,
        'oneClick': 0,
        'richkingStyle': 0
      },
      rules: {
        lv: [
          { required: true, message: '请输入等级', trigger: 'blur' }
        ],
        integration: [
          { required: true, message: '请输入vip积分', trigger: 'blur' }
        ],
        taskRewardBet: [
          { required: true, message: '请输入任务奖励倍率', trigger: 'blur' }
        ],
        spinsRestore: [
          { required: true, message: '请输入盾牌槽增量', trigger: 'blur' }
        ],
        shieldGroove: [
          { required: true, message: '请输入体力恢复增量', trigger: 'blur' }
        ],
        avatarBox: [
          { required: true, message: '请选择头像框', trigger: 'change' }
        ],
        shopAppend: [
          { required: true, message: '请输入商店体力增量', trigger: 'blur' }
        ],
        attackCoinsPro: [
          { required: true, message: '请输入打成功金币增加', trigger: 'blur' }
        ],
        stealCoinsPro: [
          { required: true, message: '请输入偷钱金币增加', trigger: 'blur' }
        ],
        mock: [
          { required: true, message: '请选择嘲讽图', trigger: 'change' }
        ]
      },
      avatarBoxArr: [
        { label: '初级头像框', value: 1 },
        { label: '中级头像框', value: 2 },
        { label: '高级头像框', value: 3 },
        { label: '至尊头像框', value: 4 },
        { label: 'XX头像框', value: 5 }
      ],
      mockArr: [
        { label: '无', value: 0 },
        { label: '嘲讽图<1>', value: 1 },
        { label: '嘲讽图<2>', value: 2 },
        { label: '嘲讽图<3>', value: 3 },
        { label: '嘲讽图<4>', value: 4 },
        { label: '嘲讽图<5>', value: 5 }
      ]
    }
  },
  created() {
    const lv = this.$route.query.id
    if (lv > 0) {
      this.getTables(lv)
    }
  },
  methods: {
    getTables(lv) {
      getVipCfgList({ name: lv }).then(res => {
        if (res.code === 200) {
          this.formData = res.data[0]
        } else {
          this.msgError(res.msg)
        }
      })
    },
    submitForm() {
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          if (this.formData.lv <= 0) {
            this.msgError('vip等级不能是0')
            return
          }
          this.formData.shopAppend = parseFloat(this.formData.shopAppend)
          const data = JSON.stringify(this.formData)
          console.log(data)
          updateVipCfg({ data: data }).then(res => {
            if (res.code === 200) {
              this.msgSuccess(res.msg)
              this.$router.push({ path: '/config/vip-cfg/index' })
            } else {
              this.msgError(res.msg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped>
</style>
